import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    container: 'h-2 rounded bg-grey-70',
    progress: 'bg-brand-1'
  }
} satisfies VfConfig['progressBar']
